// Generated by purs version 0.11.7
"use strict";
var Data_Array = require("../Data.Array");
var Data_Maybe = require("../Data.Maybe");
var Data_Tuple = require("../Data.Tuple");
var Halogen_VDom_Types = require("../Halogen.VDom.Types");
var PrestoDOM_Core = require("../PrestoDOM.Core");
var PrestoDOM_Types = require("../PrestoDOM.Types");
var keyed = function (elemName) {
    return function (props) {
        return Halogen_VDom_Types.Keyed.create(new Halogen_VDom_Types.ElemSpec(Data_Maybe.Nothing.value, elemName, props));
    };
};
var element = function (elemName) {
    return function (props) {
        return Halogen_VDom_Types.Elem.create(new Halogen_VDom_Types.ElemSpec(Data_Maybe.Nothing.value, elemName, props));
    };
};
var leaf = function (elem) {
    return function (props) {
        return element(elem)(props)([  ]);
    };
};
var imageView = leaf("imageView");
var listView = leaf("listView");
var progressBar = leaf("progressBar");
var $$switch = leaf("switch");
var textView = leaf("textView");
var viewWidget = leaf("viewWidget");
var webView = leaf("webView");
var node = function (elem) {
    return element(elem);
};
var frameLayout = node("frameLayout");
var horizontalScrollView = node("horizontalScrollView");
var linearLayout = node("linearLayout");
var relativeLayout = node("relativeLayout");
var scrollView = node("scrollView");
var shimmerFrameLayout = node("shimmerFrameLayout");
var tabLayout = node("tabLayout");
var viewPager = node("viewPager");
var editText = leaf("editText");
var checkBox = leaf("checkBox");
var calendar = leaf("calendar");
var button = leaf("button");
module.exports = {
    element: element,
    keyed: keyed,
    linearLayout: linearLayout,
    relativeLayout: relativeLayout,
    horizontalScrollView: horizontalScrollView,
    scrollView: scrollView,
    frameLayout: frameLayout,
    shimmerFrameLayout: shimmerFrameLayout,
    tabLayout: tabLayout,
    imageView: imageView,
    editText: editText,
    listView: listView,
    progressBar: progressBar,
    textView: textView,
    viewPager: viewPager,
    button: button,
    calendar: calendar,
    checkBox: checkBox,
    "switch": $$switch,
    viewWidget: viewWidget,
    webView: webView
};



//////////////////
// WEBPACK FOOTER
// ./output/PrestoDOM.Elements/index.js
// module id = 277
// module chunks = 0